













































































































import { Component, Vue } from 'vue-property-decorator';
import URI from 'urijs';
import filesize from 'filesize';

@Component({
  filters: {
    filesize(text: any): any {
      try {
        const size = parseInt(text, 10);
        return filesize(size);
      } catch {
        return "size unknown";
      }
    },
  },
  watch: {
    '$route': 'routeChanged',
  },
})
export default class Alert extends Vue {
  private id: string = "";
  private alert: any = null;
  private info: any = null;

  private loaded: boolean = false;

  private severityVariants: Map<string, string> = new Map<string, string>()
    .set('EXTREME', 'danger')
    .set('SEVERE', 'warning')
    .set('MODERATE', 'info')
    .set('MINOR', 'success');

  private certaintyVariants: Map<string, string> = new Map<string, string>()
    .set('OBSERVED', 'danger')
    .set('LIKELY', 'warning')
    .set('POSSIBLE', 'info')
    .set('UNLIKELY', 'success');

  private urgencyVariants: Map<string, string> = new Map<string, string>()
    .set('IMMEDIATE', 'danger')
    .set('EXPECTED', 'warning')
    .set('FUTURE', 'info')
    .set('PAST', 'success');

  private responseTypeVariants: Map<string, string> = new Map<string, string>()
    .set('SHELTER', 'danger')
    .set('EVACUATE', 'danger')
    .set('PREPARE', 'warning')
    .set('EXECUTE', 'warning')
    .set('AVOID', 'warning')
    .set('MONITOR', 'info')
    .set('ASSESS', 'info')
    .set('ALL_CLEAR', 'success')
    .set('NONE', 'success');

  public fetch(): void {
    const id: string[] = this.id.split(':');

    if (id.length !== 2) {
      return;
    }

    this.loaded = false;

    const url = new URI('https://alerts.zacharyseguin.ca/api/alerts/');
    url.filename(id[0]);

    fetch(url.toString())
      .then((r) => r.json())
      .then((r) => {
        this.info = r.infos[parseInt(id[1], 10)];
        delete r.infos;
        this.alert = r;

        this.loaded = true;
      });
  }

  private routeChanged(n: any, old: any): void {
    if (n.params.id && n.params.id !== this.id) {
      this.id = n.params.id;
      this.fetch();
    }
  }

  public mounted(): void {
    this.id = this.$route.params.id;
    this.fetch();
  }

  private get headline(): string {
    if (this.alert && this.info && this.info.headline) {
      let headline = this.info.headline.trim();

      // NWS
      if (this.alert.system === 'nws') {
        // tslint:disable-next-line:max-line-length
        const regex = /^(.*)issued\s+(january|february|march|april|may|june|july|august|september|october|november|december).*$/gi;
        headline = headline.replace(regex, '$1');
      }

      return headline.replace(/\n/g, '<br />');
    }

    return '';
  }

  private get description(): string {
    if (this.alert && this.info && this.info.description) {
      let description = this.info.description;

      // Environment Canada styling
      if (this.alert.system === 'naads') {
        description = description.replace(/\n+###\n+/g, '<hr />');
      }

      // NWS
      if (this.alert.system === 'nws') {
        description = description.replace(/\n\n/g, '<br /><br />');
        description = description.replace(/\n(?!\*)/g, ' ');
      }

      return description.trim().replace(/\n/g, '<br />');
    }

    return '';
  }

  private get instruction(): string {
    if (this.alert && this.info && this.info.instruction) {
      let instruction = this.info.instruction;

      // NWS
      if (this.alert.system === 'nws') {
        instruction = instruction.trim();
        instruction = instruction.replace(/\n\n/g, '<br /><br />');
        instruction = instruction.replace(/\n(?![\*])/g, ' ');
      }

      return instruction.trim().replace(/\n/g, '<br />');
    }

    return '';
  }

  private get displayAreas(): string[] {
    if (this.info && this.info.areas) {
      let areas = this.info.areas.map((area: any) => area.description).sort();

      // Handle nws
      if (this.alert.system === 'nws') {
        areas = areas[0].split(';').sort();
      }

      return areas;
    }

    return [];
  }

  private get isBroadcastImmediate(): boolean {
    const param = this.info.parameters['layer:SOREM:1.0:Broadcast_Immediately'];
    return Array.isArray(param) && param.length > 0 && param[0].toLowerCase() === 'yes';
  }

  private get broadcastText(): string {
    if ((this.info.parameters['layer:SOREM:1.0:Broadcast_Text'] || []).length > 0) {
      return this.info.parameters['layer:SOREM:1.0:Broadcast_Text'][0].trim().replace(/\n/g, '<br />');
    }

    return '';
  }

  private get isWireless(): boolean {
    const param = this.info.parameters['layer:SOREM:2.0:WirelessImmediate'];
    return Array.isArray(param) && param.length > 0 && param[0].toLowerCase() === 'yes';
  }

  private get wirelessText(): string {
    if ((this.info.parameters['layer:SOREM:2.0:WirelessText'] || []).length > 0) {
      return this.info.parameters['layer:SOREM:2.0:WirelessText'][0].trim().replace(/\n/g, '<br />');
    }

    return '';
  }
}
